import { useController, Path } from 'react-hook-form'

import { IFormConditionProps } from './FormWhen.props'

export function FormWhen<T extends Record<string, any>, F extends Path<T>>({
  is,
  fieldName,
  control,
  children,
}: IFormConditionProps<T, F>): JSX.Element | null {
  const { field } = useController<T, F>({ name: fieldName, control })
  return is(field.value) ? children : null
}
